import { Stack } from '@chakra-ui/react';

import { TaxResidency } from '__generated__/GQL';
import asBentoPage from 'common/bento/hoc/asBentoPage';
import useCountriesList from 'common/countries/useCountriesList';
import Button from 'components/_core/Button';
import InformationSection from 'features/Onboarding/components/InformationSection';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';
import VerifyInformationCallout from 'features/Onboarding/components/VerifyInformationCallout';
import { formatComplianceInformationItems } from 'features/Onboarding/helpers/formatComplianceInformationItems';

import Header from '../../../../components/Header';
import { FiscalSituationSchema } from '../ComplianceForm/components/Form';
import locales from './locales';

interface ComplianceRecapProps {
  complianceValues: Partial<FiscalSituationSchema>;
  taxResidencies: Pick<TaxResidency, 'country' | 'fiscalId'>[];
  onNext: () => void;
}

/**
 * A page that shows a recap of the user’s compliance info
 */
const ComplianceRecap = asBentoPage<ComplianceRecapProps>(
  ({ complianceValues, Layout, onNext, onPrev, taxResidencies }) => {
    const countriesOptions = useCountriesList();

    const { complianceInformationItems, secondaryComplianceInformationItems } =
      formatComplianceInformationItems(
        complianceValues,
        taxResidencies,
        countriesOptions,
      );

    return (
      <Layout data-testid="compliance" nav={<OBNavigation onPrev={onPrev} />}>
        <Header title={locales.title} />

        <Stack spacing="space-40">
          <VerifyInformationCallout />
          <InformationSection
            iconName="euro"
            items={complianceInformationItems}
            secondaryItems={secondaryComplianceInformationItems}
            title={locales.section}
          />
          <Button isExpanded onClick={onNext}>
            {locales.cta}
          </Button>
        </Stack>
      </Layout>
    );
  },
);

export default ComplianceRecap;
